/**
 * Procedure Categories and Procedures for Diploma in Immunohaematology and Blood Transfusion (DIHBT) students
 * Extracted with strict evidence from official NMC PDF
 */
export const IMMUNOHAEMATOLOGY_PROCEDURES = {
  "Blood Collection & Phlebotomy": [
    "Whole Blood Collection / Donor Phlebotomy",
    "Autologous Blood Collection",
    "Therapeutic Phlebotomy",
    "Donor Apheresis Collection (Plateletpheresis / Plasmapheresis)",
  ],
  "Blood Component Processing": [
    "Preparation of Packed Red Blood Cells (PRBC)",
    "Preparation of Fresh Frozen Plasma (FFP)",
    "Preparation of Platelet Concentrate",
    "Preparation of Cryoprecipitate",
    "Leuko-Filtration of Blood Components",
    "Quality Control Testing of Blood Components",
  ],
  "Immunohematology & Serology": [
    "ABO and Rh Blood Grouping",
    "Cross-Matching (Pre-Transfusion Compatibility Testing)",
    "Direct Antiglobulin Test (DAT / Direct Coombs' Test)",
    "Indirect Antiglobulin Test (IAT / Indirect Coombs' Test)",
    "Red Cell Antibody Screening and Identification",
    "Titration of Anti-D, Anti-A, and Anti-B Antibodies",
    "Red Cell Elution",
    "Red Cell Adsorption",
    "Minor Blood Group Typing",
    "Saliva Inhibition Test",
    "Resolution of ABO Discrepancy",
    "Cryopreservation of Reagent Red Cells",
  ],
  "Infection Screening & Laboratory Diagnostics": [
    "Donor Screening Tests for Transfusion Transmitted Infections (TTIs)",
    "Syphilis Serological Testing (Non-Treponemal and Treponemal Antibody Tests)",
    "Gram Staining of Biological Fluids",
  ],
  "Therapeutic Interventions": [
    "Therapeutic Plasma Exchange (TPE)",
  ],
};

export const IMMUNOHAEMATOLOGY_CATEGORIES = Object.keys(IMMUNOHAEMATOLOGY_PROCEDURES);

export const isDiplomaInImmunohaematologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    (
      d.includes("dihbt") ||
      d.includes("immunohaematology") ||
      d.includes("immunohematology") ||
      d.includes("transfusion")
    ) &&
    !(d.includes("md") || d.includes("master of medicine"))
  );
};
